// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__4ZHet","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1D5w2"};